import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";

export default async function callShippingJobs(component, job_id) {
  const Authorization = "bearer " + localStorage.getItem("token");
  component.setState({ isLoading: true });
  const resp = await fetch(
    `${API_URL}rest/V1/rider/getOrdersByJobId/${job_id}/in-transit`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json", Accept, Authorization },
      // body: JSON.stringify({ rider_id, trip_id })
    }
  )
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("callShippingJobs", data);
      localStorage.setItem("callShippingJobs",JSON.stringify(data))
      if (data[0] && data[0].data) {
        component.props.actionProcessingJobs(data[0].data);
      } else {
        component.props.actionProcessingJobs("failure");
      }
      return data;
    });
  component.setState({ isLoading: false });
  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/callShippingJobs.js